import {Component, OnInit} from '@angular/core';
import {EducationCenter, User} from '../../../shared/models';
import {EducationCenterService} from '../../../shared/services';
import {takeUntil} from 'rxjs/operators';
import {AuthService} from '../../../shared/modules/auth/auth.service';
import {Subject} from 'rxjs';
import {SeoUtil} from '../../../shared/utils';
import {environment} from '../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-centers',
  templateUrl: './centers.component.html'
})
export class CentersComponent implements OnInit {
  user: User;
  centers: Array<EducationCenter> = [];
  selectedPage: number = 1;
  totalPages: number = 0;

  loading: boolean;

  private destroy$ = new Subject();

  constructor(private educationCenterService: EducationCenterService,
              private authService: AuthService,
              private translateService: TranslateService,
              private seoUtil: SeoUtil) {
  }

  ngOnInit(): void {
    this.seoUtil.updateTitle(this.translateService.instant('Edukacijski centri za kvalitetniju medicinsku izobrazbu'));
    this.seoUtil.updateMetaTags([
      {property: 'og:title', content: this.translateService.instant('Edukacijski centri za kvalitetniju medicinsku izobrazbu')},
      {property: 'og:url', content: environment.sites.root + 'centers'}
    ]);
    this.fetchCenters();
    this.handleUserChange();
  }

  ngOnDestroy(): void {
    this.seoUtil.setDefaultMetaTags();
    this.seoUtil.setDefaultTitle();
    this.destroy$.next();
    this.destroy$.complete();
  }

  coursesCount(center: EducationCenter): string {
    return center.categories
      .map(categ => categ.course_ids.split(',').length)
      .reduce((a, b) => a + b, 0) + ' ' + this.translateService.instant('tečaja')
  }

  private handleUserChange() {
    if (this.authService.isLoggedIn()) {
      this.authService.getAuthUser().subscribe(user => {
        this.user = user;
      });
    } else {
      this.user = null;
    }
    this.authService.userChanged()
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user;
      });
  }

  private fetchCenters(): void {
    this.loading = true;
    this.educationCenterService.getAll()
      .subscribe(centers => {
        this.centers = centers;
        this.loading = false;
      });
  }

}
